export const background000 = '#fff';
export const background050 = '#f3f7ff';
export const background100 = '#ebf1ff';
export const background600 = '#d7e3ff';
export const background700 = '#bed1ff';
export const primary050 = '#adc9ff';
export const primary080 = '#2e4068';
export const primary100 = '#00143c';
export const primary400 = '#1d2e57';
export const primary500 = '#162751';
export const primary600 = '#000c24';
export const primary700 = '#00427d1a';
export const text000 = '#fff';
export const text100 = '#7383a6';
export const text200 = '#66728a';
export const text300 = '#96a3c4';
export const text600 = '#000';
export const yellow050 = '#faff05';
export const yellow100 = '#d3d600';
export const yellow200 = '#f1f004';
export const green400 = '#08d228';
export const green500 = '#06a721';
export const blue400 = '#00afff';
export const orange400 = '#eb7400';
export const red400 = '#f23c3e';
export const COLORS = {
    background000,
    background050,
    background100,
    background600,
    background700,
    primary050,
    primary080,
    primary100,
    primary400,
    primary500,
    primary600,
    primary700,
    text000,
    text100,
    text200,
    text300,
    text600,
    yellow050,
    yellow100,
    yellow200,
    green400,
    green500,
    blue400,
    orange400,
    red400,
};
